import apiMiddleware from "../../../api/apiMiddleware";

export const fetchDashboardSummary = async () => {
  const res = await apiMiddleware.get("/admin/dashboard-summary");
  return res.data?.data ?? null;
};
